<template>
  <div id="app" :style="{ fontSize: fontSize + 'px' }">
    <Layout></Layout>
  </div>
</template>

<script>
import Layout from './components/Layout.vue'

export default {
  name: 'app',
  components: {
    Layout
  },
  data () {
    return {
      overWidth: document.documentElement.clientWidth,
      fontSize: 14
    }
  },
  watch: {
    overWidth (val) {
      this.overWidth = val
      this.fontSize = this.getFontSize()
    }
  },
  methods: {
    getFontSize () {
      if (this.overWidth > 768) {
        return 768 / 320 * 12        
      } else {
        return this.overWidth / 320 * 12
      }
    }
  },
  mounted () {
    window.onresize = () => {
      this.overWidth = document.documentElement.clientWidth
    }
  },
  created () {
    this.fontSize = this.getFontSize()
  }
}
</script>

<style>
* {
    padding: 0;
    margin: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: no-repeat 0 0;
    background-size: 100% auto;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
html {
  font-size: 12px;
}
body {
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  color: #333;
  /* text-align: center; */
  background-color: #ffffff
}
li {
    list-style: none;
}
button {
    outline: none;
}
a {
  text-decoration: none;
  color: inherit;
}
#app {
  font-family: Avenir,Helvetica,Arial,sans-serif;
  -moz-osx-font-smoothing: grayscale;
}
.app {
  margin: 0 auto;
}
</style>
